module.exports = __webpack_public_path__ + "images/places/training_772-79ac885d1c047f03236585b69ddbc36a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_772.jpg
 ** module id = 330
 ** module chunks = 0
 **/